import React from 'react';
import PropTypes from 'prop-types';
import { loadVODPlayer } from '@wix/wix-vod-shared/src/widget/utils/load-player';
import bi from 'shared/bi/bi';
import { vodAdapterLite } from 'shared/utils/adapters/vod-lite';
import getVidiUrls from 'shared/selectors/vidi-urls';
import Spinner from '@wix/wix-vod-shared/src/widget/ui-components/loading-spinner/loading-spinner';

import styles from './video-preview.styl';

class VideoPreview extends React.Component {

  static propTypes = {
    channelId: PropTypes.string,
    instance: PropTypes.string,
    fallbackComponent: PropTypes.node,
    width: PropTypes.number,
    height: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      vidiUrls: [],
      uploadingError: false,
      VODPlayer: null,
    };

    this.loadUrls();
  }

  componentDidMount() {
    loadVODPlayer()
      .then(playerModule => {
        this.setState({ VODPlayer: playerModule.default });
      });
  }

  loadUrls() {
    const { channelId, instance } = this.props;

    bi.logWidgetSystem('channel.cover.videoPreview.loadUrls.started');
    vodAdapterLite.list.getMediaUrls(channelId, { instance })
      .then(
        videoUrls => {
          bi.logWidgetSystem('channel.cover.videoPreview.loadUrls.loaded');
          this.setState({
            vidiUrls: getVidiUrls({ videoUrls }),
            uploadingError: false,
          });
        },
        () => {
          bi.logWidgetSystem('channel.cover.videoPreview.loadUrls.failed');
          this.setState({ uploadingError: true });
        }
      );
  }

  render() {
    const { width, height, fallbackComponent } = this.props;
    const { vidiUrls, uploadingError, VODPlayer } = this.state;

    if (uploadingError) {
      return fallbackComponent;
    }

    if (!VODPlayer) {
      return <Spinner />;
    }

    return (
      <div className={styles['player-container']}>
        <VODPlayer width={width}
                   height={height}
                   vidiUrls={vidiUrls}
                   canShowTitle={false}
                   controls={false}
                   muted
                   autoPlay
                   loop />
      </div>
    );
  }
}

export default VideoPreview;



// WEBPACK FOOTER //
// ./src/widget/containers/channel-cover/video-preview/video-preview.js